import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { InfoCircle } from "react-bootstrap-icons";

interface PropsData {
  msg?: string;
  iconSize?: number;
  iconColor?: string;
  bgColor?: string;
}

const Info = ({
  msg = "You can select multiple options here!",
  iconSize = 18,
  iconColor = "#66C15E",
}: PropsData) => {
  const renderTooltip = (props: any) => (
    <Tooltip
      id="info-tooltip"
      {...props}
      style={{
        ...props.style,
        borderRadius: "8px",
        padding: "8px 12px",
        fontSize: "13px",
        fontWeight: 500,
      }}
    >
      {msg}
    </Tooltip>
  );

  return (
    <OverlayTrigger placement="top" overlay={renderTooltip}>
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          marginLeft: "6px",
          transition: "all 0.2s ease",
        }}
        onMouseEnter={(e) =>
          (e.currentTarget.style.transform = "scale(1.15)")
        }
        onMouseLeave={(e) =>
          (e.currentTarget.style.transform = "scale(1)")
        }
      >
        <InfoCircle size={iconSize} color={iconColor} />
      </span>
    </OverlayTrigger>
  );
};

export default Info;